module.exports = __webpack_public_path__ + "static/media/hydrafusion.05dbb7e3.png";